import { useMemo } from 'react';
import { useChannel } from '@core/channel';
import { useContextParams } from '@core/params/context';
import { useSubscriptionFlags } from '@embed/hooks/subscriptionFlags/useSubscriptionFlags';
function getPromoUrl({ host, isPlg, product, widget }) {
    const query = `?utm_source=${host}&utm_medium=branding_referrals&utm_campaign=${product ?? ''}&utm_content=${widget}`;
    const url = isPlg
        ? 'https://firework.com/shopify-shoppable-video/'
        : 'https://firework.com/video-solutions-for-entrepreneurs/';
    return `${url}${query}`;
}
/**
 *
 * @returns promo URL used for branding link
 */
export const usePromoUrl = (args) => {
    const params = useContextParams();
    const channel = useChannel({
        username: params.channel,
        encodedId: params.channel_id,
        target: params.target,
    });
    const subscriptionFlags = useSubscriptionFlags(channel);
    const isPlg = subscriptionFlags['50_percent_traffic_widget_display'];
    const host = typeof window !== 'undefined' ? window.location.hostname : '';
    return useMemo(() => {
        return getPromoUrl({
            host,
            isPlg,
            product: args.product,
            widget: args.widget,
        });
    }, [args.product, args.widget, host, isPlg]);
};
